import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import roo_wor_haz_lev from "../img/sswpIcons/Roof/roo_wor_haz_lev.png";
import roo_wor_dec_tru from "../img/sswpIcons/Roof/roo_wor_dec_tru.png";
import roo_wor_edg_pro from "../img/sswpIcons/Roof/roo_wor_edg_pro.png";
import roo_wor_a_lad from "../img/sswpIcons/Roof/roo_wor_a_lad.png";
import roo_wor_gua_ope from "../img/sswpIcons/Roof/roo_wor_gua_all_ope.png";
import roo_wor_mew from "../img/sswpIcons/Roof/roo_wor_mew.png";
import roo_wor_net_bea_bag from "../img/sswpIcons/Roof/roo_wor_net_bea_bag.png";
import roo_wor_oh_lin from "../img/sswpIcons/Roof/roo_wor_oh_lin.png";
import roo_wor_roo_lad from "../img/sswpIcons/Roof/roo_wor_roo_lad.png";
import roo_wor_sti from "../img/sswpIcons/Roof/roo_wor_sti.png";
import roo_wor_sto from "../img/sswpIcons/Roof/roo_wor_saf_sto.png";
import roo_wor_war_sig from "../img/sswpIcons/Roof/roo_wor_war_sig.png";
import roo_wor_wea from "../img/sswpIcons/Roof/roo_wor_wea.png";
import roo_wor_sit_spe_met from "../img/sswpIcons/Roof/roo_wor_sit_spe_met.png";
const json = {
    icon: roo_wor_haz_lev,
    name: "Roof Work & Roof Space",
    text: "",
    icons: {
        roo_wor_wea: {
            name: "Weather",
            icon: roo_wor_wea,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Windy Weather, it may be necessary to{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Cease working at height operations" />
                            <ListItem text="Remove loose material, or tie them down to prevent blowing off or falling" />
                            <ListItem text="Stop working where tools are being blown off (e.g. brick laying)" />
                            <ListItem text="Cranes must NOT be operated at wind speeds above those specified by the manufacturer" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Foggy Weather/heavy precipitation hampering vision,
                            it may be necessary to
                        </Typography>
                        <ol>
                            <ListItem text="Cease works requiring traffic management, if minimum visibility requirements cannot be met " />
                            <ListItem text="Cease crane or lifting operations requiring signalling/ vision" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Icy Weather, it may be necessary to
                        </Typography>
                        <ol>
                            <ListItem text="Cease working at height operations" />
                            <ListItem text="Cease roadwork operations, or other works where plant is being used" />
                            <ListItem text="Provide thermal clothing to prevent hypothermia. Also drink plenty of fluids, preferably warm, sweet beverages" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Sun low on the horizon/Sun Dazzle, it may be
                            necessary to{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Cease works requiring traffic management, if minimum visibility requirements cannot be met " />
                            <ListItem text="Cease crane or lifting operations requiring signalling/ vision" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Hot sunny weather, consider
                        </Typography>
                        <ol>
                            <ListItem text="Sun protection, sunblock, light full length garments, hats or head gear" />
                            <ListItem text="Drinking water for dehydration" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        roo_wor_war_sig: {
            name: "Warning Signs",
            icon: roo_wor_war_sig,
            text: (
                <ul>
                    <ListItem text="Signs will alert workers/public that they are approaching high-risk areas (e.g. exclusion zones, fall risks etc)." />
                    <ListItem text="Signs should use standardised graphical pictograms to communicate the hazard and may have supplementary information in written format." />
                    <Li>
                        <Typography variant="title">
                            Graphical symbols should NOT be combined to convey
                            more than one safety message. E.g. separate symbols
                            for hard hat and eye protection.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Sign Type</th>
                                    <th>Meaning</th>
                                    <th>Shape & Colour</th>
                                </tr>
                                <tr>
                                    <td>Prohibition</td>
                                    <td>Not permitted</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Round </li>
                                            <li>Backing colour: White</li>
                                            <li>
                                                Symbol colour: Black with red
                                                diagonal
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fire fighting</td>
                                    <td>Location and identification of type</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle </li>
                                            <li>Backing colour: Red</li>
                                            <li>Symbol colour: White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Warning</td>
                                    <td>Take precaution</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Triangle</li>
                                            <li> Backing colour: Yellow</li>
                                            <li> Symbol colour: Black</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Mandatory</td>
                                    <td>You Must</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Round</li>
                                            <li> Backing colour: Blue</li>
                                            <li> Symbol colour: White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Emergency escape</td>
                                    <td>Escape route</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle </li>
                                            <li>Backing colour: Green</li>
                                            <li>Symbol colour: White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Supplementary Information</td>
                                    <td>Additional Info</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle</li>
                                            <li> Backing colour: White</li>
                                            <li> Symbol colour: Black</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Obstacles</td>
                                    <td>Collision risk</td>
                                    <td>
                                        <ul>
                                            <li>Chevron</li>
                                            <li> Black/Yellow </li>
                                            <li>Red/White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Traffic Route</td>
                                    <td>Vehicles to keep between</td>
                                    <td>Continuous white or yellow lines.</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        roo_wor_a_lad: {
            name: "A Ladder",
            icon: roo_wor_a_lad,
            text: (
                <ul>
                    <ListItem text="Check all four step ladder feet are in contact with firm, level ground. Ensure locking devices are engaged. Ladders should not be placed near openings" />
                    <ListItem text="Only one person should use at a time and only carry light materials and tools. Maintain three points of contact " />
                    <ListItem text="Don’t overreach. Don’t work on the top three steps unless there is a suitable handhold. Avoid work that will impose a side load (if this is a risk, the ladder should be tied off)." />
                    <ListItem text="They are not to be used as supports for platforms" />
                </ul>
            )
        },
        roo_wor_roo_lad: {
            name: "Roof Ladders",
            icon: roo_wor_roo_lad,
            text: (
                <ul>
                    <ListItem text="Roof ladders should be used for accessing up and down slope roofs and in conjunction with a properly constructed scaffold platform." />
                    <ListItem text="They must be CE marked and be free from defects." />
                    <ListItem text="They should be long enough to reach and be securely anchored around the roof ridge. They must be strong enough for the span. The anchoring should not depend on the ridge capping which is liable to breakage, but should bear on the opposite slope." />
                    <ListItem text="They should be secured to prevent accidental movement" />
                    <ListItem text="You should not use eaves gutters as footing or to support a roof ladder." />
                </ul>
            )
        },
        roo_wor_edg_pro: {
            name: "Edge Protection",
            icon: roo_wor_edg_pro,
            text: (
                <ul>
                    <ListItem text="All edges, where there is a risk of operatives falling off must be protected by barriers, handrails, mid-rails, toe-boards etc." />
                    <ListItem text="All edges where there is a risk of materials falling, must be protected using scaffolding/ platforms." />
                    
                </ul>
            )
        },
        roo_wor_mew: {
            name: "MEWP",
            icon: roo_wor_mew,
            text: (
                <ul>
                    <ListItem text="Operators need appropriate training for the particular MEWP they are using, including assessment of suitability and risks in accordance with the manufacturer’s instructions. The manufacturer’s instructions will include a pre-operational checklist that must be completed before the MEWP is used." />
                    <ListItem text="A familiarisation induction should be given upon delivery to any operative using the MEWP. A ground person should also be briefed on how to use the ground controls, or any emergency decent controls." />
                    <ListItem text="The MEWP must have the required safe working load for the task (including any equipment, material and the number of persons that must be carried). Material loading should be limited to small, securable amounts for handwork.  In general, materials should be lifted by a separate telescopic handler, and loose materials should not be carried on the MEWP." />
                    <ListItem text="The MEWP should be CE marked. The MEWP must have a certificate of thorough examination valid within the last 6 months." />
                    <Li>
                        <Typography variant="title">
                            The workplace must be assessed, having regard to
                        </Typography>
                        <ol>
                            <ListItem text="Level ground with sufficient bearing capacity. They should not be used in close proximity to trenches, excavations or ground that has been filled." />
                            <ListItem text="Sufficient space/manoeuvring area available to operate the MEWP free from obstructions." />
                            <ListItem text="The operating area for the MEWP must be kept free from any other site activities that may be ongoing." />
                            <ListItem text="Overhead electricity lines" />
                            <ListItem text="Overhead obstacles that could lead to trapping or crushing injuries" />
                            <ListItem text="Heavy wind or rain will effect the operation of the MEWP and may effect the bearing capacity of the ground" />
                        </ol>
                    </Li>
                    <ListItem text="Keep the MEWP working platform free from obstacles (e.g. trailing leads or loose materials)" />
                    <ListItem text="Servicing or refuelling any tools should be done at ground level." />
                    <ListItem text="Any fault must be reported, and the MEWP clearly tagged as “out of service” with the keys removed." />
                    <ListItem text="Generally boom type MEWPs require a full body harness with a short restraint type lanyard (due to risk of boom swing, jolt or tilt)" />
                    <ListItem text="When working near water, risks associated with drowning (wearing a life jacket) are assessed compared to risks associated with falling (wearing a harness). The appropriate control should be selected." />
                    <ListItem text="Consider Hard Hats that have chin straps where appropriate when selecting PPE." />
                </ul>
            )
        },
        roo_wor_dec_tru: {
            name: "Deck Trusses",
            icon: roo_wor_dec_tru,
            text: (
                <ul>
                    <ListItem text="Trusses can be decked out to prevent falls" />
                </ul>
            )
        },

        roo_wor_net_bea_bag: {
            name: "Nets/Bean Bags",
            icon: roo_wor_net_bea_bag,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Nets should only be erected by competent and trained
                            operatives. They must be installed in accordance
                            with the manufacturer’s instructions, including
                            within the specified range of fixing points. The
                            fall height and catching width is given as
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <td>Fall Height</td>
                                    <td>{"< 1m"}</td>
                                    <td>{"< 3m"}</td>
                                    <td>{"< 6m"}</td>
                                </tr>
                                <tr>
                                    <td>Catching width</td>
                                    <td>> 2m</td>
                                    <td>> 2.5m</td>
                                    <td>> 3</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Nets should be fitted to be less than 2m from fall area (at maximum point of sag)." />
                    <ListItem text="Adequate clearance (from staff, plant or stored materials) must be maintained underneath the net." />
                    <ListItem text="Material or rubbish should not be allowed to fall into nets." />
                    <ListItem text="Bean Bags (Air bags) should only be used where it is not possible to use safety nets. They must be of sufficient strength and have enough air pressure to ensure the falling person does not make contact with the ground. They must be installed in accordance with the manufacturer’s instructions. The guidance above for catching width should be followed over the entire length of the hazard. Bean-bags may be interconnected to achieve this using the manufacturer approved secure couplings." />
                </ul>
            )
        },
        roo_wor_oh_lin: {
            name: "Overhead Lines",
            icon: roo_wor_oh_lin,
            text: (
                <ul>
                    <ListItem text="The ESB should be consulted to establish the voltages present." />
                    <ListItem text="Follow the practice outlined in “Avoiding Danger from Overhead Electricity Lines”" />
                    <Li>
                        <Typography variant="title">
                            The Hazard Zone alongside overhead lines should be
                            isolated from plant activity by physical means
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>
                                        Distance from edge of Hazard Zone to
                                        overhead line
                                    </th>
                                </tr>
                                <tr>
                                    <td>LV, 10kV, 20kV, 38kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV, 220kV, 400kV</td>
                                    <td>10.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            The Exclusion Zone around live wires must never be
                            breached.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>Radius around live wire</th>
                                </tr>
                                <tr>
                                    <td>Insulated LV</td>
                                    <td>1.0m</td>
                                </tr>
                                <tr>
                                    <td>Bare LV, 10kV, 20kV, 38kV</td>
                                    <td>3.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV</td>
                                    <td>4.5m</td>
                                </tr>
                                <tr>
                                    <td>220kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>400kV</td>
                                    <td>8.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Crossing points for plant underneath overhead lines should be provided using “goalposts”. These should be max 9m width and 4.2m max height." />
                    <ListItem text="No Tip Zones can be exclusively used for road surfacing operations. These are set perpendicular to the road direction, such that no point of the no tip zone is closer than 3m to the overhead line. They must be clearly marked and provided with a dedicated banksman in direct communication with the plant operator(s)." />
                </ul>
            )
        },
        roo_wor_sti: {
            name: "Stilts",
            icon: roo_wor_sti,
            text: (
                <ul>
                    <ListItem text="Stilts should not be used where the ceiling height is > 3m, for walking backwards or on stairs." />
                    <ListItem text="Stilts can only be used on surfaces that are solid, level and can support stilt work activity. Floor surfaces must be cleared, swept and dry." />
                    <ListItem text="Stilts can only be used for light duty activities. Avoid handling long, heavy or cumbersome items." />
                    <ListItem text="The area to be plastered must be plaster ready with preparation and roughening work completed. Other workers should be kept away from the immediate area." />
                    <ListItem text="Stilts should not be used near internal openings or leading edges, where the ground is uneven/different levels, or where there is material, tools or equipment lying around. Sufficient fall controls are required in areas where stilts are to be used." />
                    <ListItem text="You should have a rigid platform for mounting/dismounting at a height equal to or greater than the height of the stilt. Stepladders should not be used. You must not balance on one stilt while attaching the other." />
                    <ListItem text="You should have a platform at the required height to access your tools/materials to avoid bending down below knee level." />
                    <ListItem text="You should work such that your Torso is vertical whenever possible." />
                    <ListItem text="Stilts must be kept clean and inspected before each use. Ensure that soles and ties are in good condition." />
                    <ListItem text="You should not continually use stilts for > 2 hours without at least a 30 minute break. You should not use stilts > 6 hours per day." />
                    <ListItem text="You should have a helper to assist you to keep the area clean and prepared, prevent bending, frequent decents or overstretching." />
                </ul>
            )
        },

        roo_wor_sto: {
            name: "Storage",
            icon: roo_wor_sto,
            text: (
                <ul>
                    <ListItem text="Materials should be stored where they cannot fall on workers below." />
                    <ListItem text="Materials should be safely stacked" />
                    <ListItem text="Access routes for operatives and plant should be kept clear. Working areas must be kept clear. Ensure adequate space for access and loading activities." />
                    <ListItem text="Debris or excavated/extracted material should be regularly removed from the area." />
                </ul>
            )
        },
        roo_wor_gua_all_ope: {
            name: "Open Holes/ Openings",
            icon: roo_wor_gua_ope,
            text: (
                <ul>
                    <ListItem text="All openings (open manholes etc) must be guarded to prevent falls. This should be done using barriers." />
                    <ListItem text="The opening should be closed or backfilled as soon as practicable." />
                    <ListItem text="When using covers, these must be set flush too, and fixed to the surrounding surface. They should have a textured surface to EN 124 (minimum 2mm) or high friction surface to USRV 35, and be strong enough for the potential loading." />
                </ul>
            )
        },
        roo_wor_sit_spe_met_sta: {
            name: "Site Specific Method Statement",
            icon: roo_wor_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
